var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-wrapper"},[_c('div',{staticClass:"normal-stars"},_vm._l((_vm.amount),function(n){return _c('div',{staticClass:"star"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }